import excelJS from 'exceljs'
import { save } from 'save-file'
import moment from 'moment-timezone'
import _ from 'lodash'

const baseColumns = [
  {name:"Pass ID",item:"pass_id",width:100},
  {name:"Grouping ID",item:"grouping_id",width:100},
  {name:"Status",item:"expiry_date",width:100, format:"status"},
  {name:"Expiry Date",item:"expiry_date",width:50, format:"date"},
  {name:"Apple Installs",item:"apple_installs",width:50},
  {name:"Google Installs",item:"google_installs",width:50},
  {name:"Sync Required",item:"sync_required",width:50, format:"yes"},
  {name:"Created",item:"creation_timestamp",width:50, format:"date"},
  {name:"Last Modified (Apple)",item:"last_modified_apple_timestamp",width:50, format:"date"},
  {name:"Last Modified (Google)",item:"last_modified_google_timestamp",width:50, format:"date"},
]

const passesListToExcel = async ({ template, fileName, data }) => {

  const columns = baseColumns.concat(getInstanceDataColumns(template))

  const workbook = new excelJS.Workbook()

  workbook.views = [
    {
      x: 0, y: 0, width: 3, height: 1000,
      firstSheet: 0, activeTab: 1, visibility: 'visible'
    }
  ]

  const font = { name: 'Courier', size: 12, bold: true }

  for (let key in data) {
    const dataItem = data[key]
    if (dataItem.length) {

      const passes_worksheet = workbook.addWorksheet(key)

      columns.map((col,idx) => passes_worksheet.getColumn(idx+1).width = col.width)

      const passes_row = passes_worksheet.getRow(1)

      columns.map((col,idx) => passes_row.getCell(idx+1).value = col.name)

      columns.map((col,idx) => passes_row.getCell(idx+1).font = font)

      dataItem.map((r, i) => {
        const row = passes_worksheet.getRow(i + 2)
      
        columns.map((col,idx) => 
          row.getCell(idx+1).value = col.format ? formatDataItem(r,col): _.get(r,col.item))
        columns.map((col,idx) => 
          row.getCell(idx+1).font = font)
      })
    }
  }


  const buffer = await workbook.xlsx.writeBuffer()

  await save(buffer, fileName + '.xlsx')
}

export default passesListToExcel

const formatDataItem = (row,col) => {

  const value = row[col.item]

  switch (col.format) {
    case "date" : return value ? moment(value,"YYYYMMDDHHmmSS").format("YYYY-MM-DD HH:mm") : "-"
    case "yes" : return value === 1 ? "yes" : ""
    case "status" : !value || value > moment().format("YYYYMMDDHHmmss") ? "current" : "expired"
  }
}

const getInstanceDataColumns = template => {
  const scanner_data_columns = Object.keys(template.scanner_instance_data)

  return scanner_data_columns.map(name => {
    const item = "scanner_instance_data." + name
    return {name:name,item:item,width:100}
  })
}
